module.exports = __webpack_public_path__ + "img/auth-stage-horizontal.5689b478.png";